import React from "react";
import { format } from "date-fns";
import { Badge } from "@/shared/components/ui/badge";
import { NotificationActions } from "./NotificationActions";
import { typeConfig } from "@/shared/utils/notificationUtils";

export const NotificationCard = ({
  notification,
  isLoading,
  onMarkAsRead,
  onRemove,
  t,
}) => {
  const config = typeConfig[notification.type] || typeConfig.SYSTEM;
  const Icon = config.icon;

  return (
    <div
      className={`p-4 rounded-xl border transition-all ${
        notification.read
          ? "bg-white border-slate-200"
          : "bg-blue-50 border-blue-200"
      } hover:shadow-md`}
    >
      <div className="flex items-start gap-4">
        <div
          className={`w-10 h-10 rounded-lg ${config.bg} flex items-center justify-center flex-shrink-0`}
        >
          <Icon className={`h-5 w-5 ${config.color}`} />
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap mb-1">
            <h3
              className={`text-sm font-semibold ${
                notification.read ? "text-slate-700" : "text-slate-900"
              }`}
            >
              {notification.title}
            </h3>

            <Badge className={config.badge} variant="secondary">
              {t(config.labelKey) || config.labelKey}
            </Badge>

            {!notification.read && (
              <div className="w-2 h-2 bg-blue-500 rounded-full" />
            )}
          </div>

          <p
            className={`text-sm mb-2 ${
              notification.read ? "text-slate-600" : "text-slate-700"
            }`}
          >
            {notification.message}
          </p>

          <p className="text-xs text-slate-500">
            {format(notification.time, "MMM dd, yyyy h:mm a")}
          </p>
        </div>

        <NotificationActions
          notification={notification}
          isLoading={isLoading}
          onMarkAsRead={onMarkAsRead}
          onRemove={onRemove}
          t={t}
        />
      </div>
    </div>
  );
};
